import { Alert } from '@mui/material'

import { useTexts } from '../../../../../useTexts'

interface NotExecutedOrdersWarningProps {
  executedCount: number
  totalCount: number
}

export function NotExecutedOrdersWarning({
  executedCount,
  totalCount,
}: NotExecutedOrdersWarningProps) {
  const texts = useTexts()
  return (
    <Alert
      severity="warning"
      sx={{
        '& .MuiAlert-message': {
          whiteSpace: 'pre-wrap',
        },
      }}
    >
      {texts.notExecutedOrdersWarning(executedCount, totalCount)}
    </Alert>
  )
}
